module.exports = __webpack_public_path__ + "static/img/result_ls_desk_angle.fc60d7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_desk_angle.jpg
// module id = kumy
// module chunks = 3